module.exports = __webpack_public_path__ + "img/0750dad18f79c94545c6edb2519f8bfb.svg";